import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-back",
  "use": "chevron-back-usage",
  "viewBox": "0 0 8 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 15\" id=\"chevron-back\"><path d=\"M1.83 7.37l5.958 6.318c.291.309.281.8-.023 1.096a.754.754 0 01-1.079-.023L.212 7.895a.785.785 0 01.011-1.086L6.698.227a.754.754 0 011.079 0 .785.785 0 010 1.097L1.83 7.37z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol